(function () {
  var root = document.querySelector('.t4s-product-buy-box[data-bb-primary-variant]');
  if (!root) return;
  var qtyInput = root.querySelector('[data-quantity-value]');
  var options = Array.prototype.slice.call(root.querySelectorAll('[data-bb-qty-option]'));
  var modal = document.querySelector('[data-bb-picker-modal]');
  if (!qtyInput || !options.length) return;

  // Avoid sticky/overflow stacking: portal modal to <body>
  if (modal && modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }

  var primary = {
    productId: root.getAttribute('data-bb-primary-product'),
    variantId: parseInt(root.getAttribute('data-bb-primary-variant'), 10),
    title: root.getAttribute('data-bb-primary-title') || '',
    price: parseInt(root.getAttribute('data-bb-primary-price'), 10) || 0,
    image: root.getAttribute('data-bb-primary-image') || ''
  };
  var moneyFormat = root.getAttribute('data-bb-money-format') || '{{amount}}';
  var extrasByTier = { 1: [], 2: [], 3: [] };
  var activeTierQty = parseInt((root.querySelector('[data-bb-qty-option].is-selected') || options[0]).getAttribute('data-bb-qty-option'), 10) || 1;
  var BUNDLE_RATE = 0.90;
  var isNlDomain = root.getAttribute('data-bb-is-nl') === 'true';
  var deliveryBadgeText = root.getAttribute('data-bb-delivery-badge') || '+ free delivery';
  var pickerItemLabel = root.getAttribute('data-bb-picker-item-label') || 'Pixelbrick';

  function formatMoney(cents) {
    var value = (Number(cents) || 0) / 100;
    var formatted = value.toFixed(2).replace('.', ',');
    if (moneyFormat.indexOf('{{amount_no_decimals}}') !== -1) {
      formatted = String(Math.round(value));
    } else if (moneyFormat.indexOf('{{amount_with_comma_separator}}') !== -1) {
      formatted = value.toFixed(2).replace('.', ',');
    } else if (moneyFormat.indexOf('{{amount}}') !== -1) {
      formatted = value.toFixed(2);
    }
    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatted)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, formatted)
      .replace(/\{\{\s*amount\s*\}\}/g, formatted);
  }

  /**
   * 1 item  → no discount
   * 2+ items → 10% off each / total
   */
  function computeBundlePricing(priceCentsList) {
    var prices = (priceCentsList || []).map(function (p) { return Math.max(0, Number(p) || 0); });
    var originalTotal = prices.reduce(function (sum, p) { return sum + p; }, 0);
    if (prices.length <= 1) {
      return {
        originalTotal: originalTotal,
        bundleTotal: originalTotal,
        totalDiscount: 0,
        displayedPrices: prices.slice()
      };
    }
    var displayedPrices = prices.map(function (productPrice) {
      return Math.round(productPrice * BUNDLE_RATE);
    });
    var bundleTotal = displayedPrices.reduce(function (sum, p) { return sum + p; }, 0);
    return {
      originalTotal: originalTotal,
      bundleTotal: bundleTotal,
      totalDiscount: originalTotal - bundleTotal,
      displayedPrices: displayedPrices
    };
  }

  function syncQty(qty) {
    qtyInput.value = String(qty);
    document.querySelectorAll('[data-quantity-value]').forEach(function (el) {
      if (el === qtyInput) return;
      el.value = String(qty);
    });
    try {
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {}
  }

  function getExtras(qty) {
    return extrasByTier[qty] || [];
  }

  function remainingSlots(tierQty) {
    var qty = tierQty || activeTierQty;
    return Math.max(0, qty - 1 - getExtras(qty).length);
  }

  function pricesForTier(tierQty) {
    var extras = getExtras(tierQty);
    if (extras.length > 0) {
      return [primary.price].concat(extras.map(function (item) { return item.price || 0; }));
    }
    // Empty multi-set: advertise N × current product (with 10% off via computeBundlePricing)
    if (tierQty > 1) {
      var advertised = [];
      for (var i = 0; i < tierQty; i++) advertised.push(primary.price);
      return advertised;
    }
    return [primary.price];
  }

  function updateTierBadge(tier) {
    var tierQty = parseInt(tier.getAttribute('data-bb-qty-option'), 10) || 1;
    var titleRow = tier.querySelector('.t4s-product-buy-box__tier-title-row');
    if (!titleRow) return;
    var badge = titleRow.querySelector('.t4s-product-buy-box__tier-badge');
    var showDelivery = tierQty === 3 && isNlDomain;
    if (showDelivery) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 't4s-product-buy-box__tier-badge';
        titleRow.appendChild(badge);
      }
      badge.textContent = deliveryBadgeText;
      badge.hidden = false;
    } else if (badge) {
      badge.hidden = true;
    }
  }

  function makeStickyThumb(src, alt) {
    var el = document.createElement('span');
    el.className = 't4s-sticky-atc__thumb';
    if (src) {
      var img = document.createElement('img');
      img.src = src;
      img.alt = alt || '';
      img.width = 48;
      img.height = 48;
      img.loading = 'lazy';
      el.appendChild(img);
    }
    return el;
  }

  function makeStickyPlaceholder() {
    var el = document.createElement('span');
    el.className = 't4s-sticky-atc__thumb is--placeholder';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<svg class="t4s-sticky-atc__thumb-brick" viewBox="0 0 32 28" width="22" height="19" focusable="false">' +
      '<rect x="2" y="8" width="28" height="18" rx="2" fill="#c8c8c8"/>' +
      '<rect x="5" y="4" width="6" height="6" rx="1" fill="#b0b0b0"/>' +
      '<rect x="13" y="4" width="6" height="6" rx="1" fill="#b0b0b0"/>' +
      '<rect x="21" y="4" width="6" height="6" rx="1" fill="#b0b0b0"/>' +
      '</svg>';
    return el;
  }

  function updateStickyBundle() {
    var sticky = document.querySelector('[data-sticky-addtocart].is--pixelart-bundle');
    if (!sticky) return;
    var thumbs = sticky.querySelector('[data-sticky-bundle-thumbs]');
    var classicImg = sticky.querySelector('[data-sticky-img]');
    var classicPrice = sticky.querySelector('[data-sticky-price]');
    var bundlePrice = sticky.querySelector('[data-sticky-bundle-price]');
    var compareEl = sticky.querySelector('[data-sticky-bundle-compare]');
    var currentEl = sticky.querySelector('[data-sticky-bundle-current]');
    var tierQty = activeTierQty;
    var extras = getExtras(tierQty);

    if (tierQty <= 1) {
      if (thumbs) {
        thumbs.hidden = true;
        thumbs.innerHTML = '';
      }
      if (classicImg) classicImg.hidden = false;
      if (classicPrice) classicPrice.hidden = false;
      if (bundlePrice) bundlePrice.hidden = true;
      sticky.classList.remove('is--bundle-multi');
      return;
    }

    sticky.classList.add('is--bundle-multi');
    if (classicImg) classicImg.hidden = true;
    if (classicPrice) classicPrice.hidden = true;
    if (bundlePrice) bundlePrice.hidden = false;

    if (thumbs) {
      thumbs.hidden = false;
      thumbs.innerHTML = '';
      thumbs.appendChild(makeStickyThumb(primary.image, primary.title));
      for (var i = 0; i < tierQty - 1; i++) {
        var plus = document.createElement('span');
        plus.className = 't4s-sticky-atc__thumb-plus';
        plus.setAttribute('aria-hidden', 'true');
        plus.textContent = '+';
        thumbs.appendChild(plus);
        var extra = extras[i];
        if (extra) thumbs.appendChild(makeStickyThumb(extra.image, extra.title));
        else thumbs.appendChild(makeStickyPlaceholder());
      }
    }

    var pricing = computeBundlePricing(pricesForTier(tierQty));
    if (currentEl) currentEl.textContent = formatMoney(pricing.bundleTotal);
    if (compareEl) {
      if (pricing.totalDiscount > 0) {
        compareEl.textContent = formatMoney(pricing.originalTotal);
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }
  }

  function publishBundleState() {
    var tierQty = activeTierQty;
    var extras = getExtras(tierQty);
    var cartItems = [{
      id: primary.variantId,
      quantity: 1,
      isPrimary: true
    }];
    extras.forEach(function (item) {
      cartItems.push({ id: item.variantId, quantity: 1, isPrimary: false });
    });
    var actualQty = cartItems.length;
    var pricing = computeBundlePricing(
      [primary.price].concat(extras.map(function (item) { return item.price || 0; }))
    );
    window.__pbBundleState = {
      tierQty: tierQty,
      qty: actualQty,
      items: cartItems,
      complete: extras.length >= Math.max(0, tierQty - 1),
      pricing: pricing
    };
    syncQty(actualQty);
    updateStickyBundle();
  }

  function updateTierPrice(tier) {
    var tierQty = parseInt(tier.getAttribute('data-bb-qty-option'), 10) || 1;
    var prices = pricesForTier(tierQty);
    var pricing = computeBundlePricing(prices);
    var priceEl = tier.querySelector('[data-bb-tier-price]');
    var compareEl = tier.querySelector('[data-bb-tier-compare]');
    if (priceEl) priceEl.textContent = formatMoney(pricing.bundleTotal);
    if (compareEl) {
      if (pricing.totalDiscount > 0) {
        compareEl.textContent = formatMoney(pricing.originalTotal);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
    updateTierBadge(tier);
  }

  function updateModalTitle() {
    if (!modal) return;
    var titleEl = modal.querySelector('.t4s-bb-picker-modal__title');
    if (!titleEl) return;
    var n = remainingSlots();
    titleEl.textContent = 'Select ' + n + ' ' + pickerItemLabel;
    var dialog = modal.querySelector('.t4s-bb-picker-modal__dialog');
    if (dialog) dialog.setAttribute('aria-label', titleEl.textContent);
  }

  function updateModalPrices() {
    if (!modal) return;
    var extras = getExtras(activeTierQty);
    var basePrices = [primary.price].concat(extras.map(function (item) { return item.price || 0; }));
    modal.querySelectorAll('[data-bb-pick-product]').forEach(function (btn) {
      var candidatePrice = parseInt(btn.getAttribute('data-price'), 10) || 0;
      var pricing = computeBundlePricing(basePrices.concat([candidatePrice]));
      var displayed = pricing.displayedPrices[pricing.displayedPrices.length - 1];
      var priceEl = btn.querySelector('[data-bb-pick-price]');
      var compareEl = btn.querySelector('[data-bb-pick-compare]');
      if (priceEl) priceEl.textContent = formatMoney(displayed);
      if (compareEl) {
        if (pricing.totalDiscount > 0 && displayed < candidatePrice) {
          compareEl.textContent = formatMoney(candidatePrice);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
    });
  }

  function renderBundle(tier) {
    var qty = parseInt(tier.getAttribute('data-bb-qty-option'), 10) || 1;
    var list = tier.querySelector('[data-bb-bundle-items]');
    var addBtn = tier.querySelector('[data-bb-add-product]');
    if (!list) return;
    var extras = getExtras(qty);
    list.querySelectorAll('[data-bb-extra-item]').forEach(function (el) {
      el.remove();
    });
    extras.forEach(function (item, index) {
      var row = document.createElement('div');
      row.className = 't4s-product-buy-box__bundle-item';
      row.setAttribute('data-bb-extra-item', String(index));
      var imgHtml = item.image
        ? '<img class="t4s-product-buy-box__bundle-item-img" src="' + item.image + '" alt="" width="40" height="40" loading="lazy">'
        : '';
      row.innerHTML = imgHtml +
        '<span class="t4s-product-buy-box__bundle-item-name"></span>' +
        '<button type="button" class="t4s-product-buy-box__bundle-item-remove" data-bb-remove-extra aria-label="Remove">&times;</button>';
      row.querySelector('.t4s-product-buy-box__bundle-item-name').textContent = item.title;
      list.appendChild(row);
    });
    if (addBtn) {
      var needsMore = qty > 1 && extras.length < qty - 1;
      addBtn.classList.toggle('is-visible', needsMore && tier.classList.contains('is-selected'));
    }
    updateTierPrice(tier);
  }

  function refreshAllBundles() {
    options.forEach(renderBundle);
    publishBundleState();
    if (modal && modal.classList.contains('is-open')) {
      updateModalTitle();
      updateModalPrices();
    }
  }

  // Sticky bar is cloned from <template> after load — re-sync when it appears
  (function waitForStickyBundle(attempts) {
    if (document.querySelector('[data-sticky-addtocart].is--pixelart-bundle')) {
      updateStickyBundle();
      return;
    }
    if (attempts > 80) return;
    window.setTimeout(function () {
      waitForStickyBundle(attempts + 1);
    }, 100);
  })(0);

  function selectOption(tier) {
    if (!tier || tier.classList.contains('is-disabled')) return;
    var qty = parseInt(tier.getAttribute('data-bb-qty-option'), 10);
    if (!qty) return;
    activeTierQty = qty;
    options.forEach(function (opt) {
      var on = opt === tier;
      opt.classList.toggle('is-selected', on);
      opt.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    refreshAllBundles();
  }

  function openModal() {
    if (!modal) return;
    if (remainingSlots() <= 0) return;
    updateModalTitle();
    updateModalPrices();
    modal.hidden = false;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function getLineItemProperties() {
    var form = document.querySelector(root.getAttribute('data-bb-form-selector') || 'form[data-type="add-to-cart-form"]');
    var props = {};
    if (form) {
      var fd = new FormData(form);
      fd.forEach(function (value, key) {
        if (!value || key.indexOf('properties[') !== 0) return;
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && match[1]) props[match[1]] = value;
      });
    }
    return props;
  }

  /** Merge same variant IDs into quantity so 2× same product adds qty 2 */
  function buildCartPayload(state, props) {
    var map = {};
    var order = [];
    (state.items || []).forEach(function (item, idx) {
      var id = String(item.id);
      if (!map[id]) {
        map[id] = { id: parseInt(item.id, 10), quantity: 0, isPrimary: false };
        order.push(id);
      }
      map[id].quantity += 1;
      if (idx === 0) map[id].isPrimary = true;
    });
    return order.map(function (id) {
      var row = { id: map[id].id, quantity: map[id].quantity };
      if (map[id].isPrimary && props && Object.keys(props).length) {
        row.properties = props;
      }
      return row;
    });
  }

  options.forEach(function (opt) {
    var selectArea = opt.querySelector('[data-bb-tier-select]');
    if (selectArea) {
      selectArea.addEventListener('click', function () {
        selectOption(opt);
      });
    }
    opt.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        selectOption(opt);
      }
    });
    var addBtn = opt.querySelector('[data-bb-add-product]');
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        selectOption(opt);
        openModal();
      });
    }
    opt.addEventListener('click', function (e) {
      if (e.target.closest('[data-bb-add-product], [data-bb-remove-extra]')) return;
      if (e.target.closest('[data-bb-tier-select]')) return;
      if (e.target.closest('[data-bb-bundle]')) return;
      selectOption(opt);
    });
  });

  root.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-bb-remove-extra]');
    if (!removeBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var tier = removeBtn.closest('[data-bb-qty-option]');
    if (!tier) return;
    var qty = parseInt(tier.getAttribute('data-bb-qty-option'), 10);
    var row = removeBtn.closest('[data-bb-extra-item]');
    var index = row ? parseInt(row.getAttribute('data-bb-extra-item'), 10) : -1;
    if (index < 0) return;
    extrasByTier[qty].splice(index, 1);
    refreshAllBundles();
  });

  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-bb-picker-close]')) {
        e.preventDefault();
        closeModal();
        return;
      }
      var pick = e.target.closest('[data-bb-pick-product]');
      if (!pick) return;
      e.preventDefault();
      var qty = activeTierQty;
      var extras = getExtras(qty);
      if (qty <= 1 || extras.length >= qty - 1) {
        closeModal();
        return;
      }
      extras.push({
        productId: pick.getAttribute('data-product-id'),
        variantId: parseInt(pick.getAttribute('data-variant-id'), 10),
        title: pick.getAttribute('data-title') || '',
        price: parseInt(pick.getAttribute('data-price'), 10) || 0,
        image: pick.getAttribute('data-image') || ''
      });
      extrasByTier[qty] = extras;
      refreshAllBundles();
      // Keep modal open until all slots filled
      if (remainingSlots(qty) > 0) {
        updateModalTitle();
        updateModalPrices();
      } else {
        closeModal();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  // Bundle ATC (including 2× same product) — buy box + sticky
  document.addEventListener('click', function (e) {
    var atc = e.target.closest('[data-action-atc]');
    if (!atc) return;
    if (!root.contains(atc) && !atc.closest('[data-sticky-addtocart]')) return;
    var state = window.__pbBundleState;
    if (!state || !state.items || state.items.length <= 1) return;

    e.preventDefault();
    e.stopPropagation();
    if (atc.disabled || atc.getAttribute('aria-disabled') === 'true') return;

    var props = getLineItemProperties();
    var payloadItems = buildCartPayload(state, props);

    atc.classList.add('is--loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: payloadItems })
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) throw new Error(json.description || json.message || 'Could not add to cart');
        return json;
      });
    }).then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (window.theme && typeof window.theme.openCartDrawer === 'function') {
        window.theme.openCartDrawer();
      } else {
        window.location.href = root.getAttribute('data-bb-cart-url') || '/cart';
      }
    }).catch(function (err) {
      window.alert((err && err.message) ? err.message : 'Something went wrong. Please try again.');
    }).finally(function () {
      atc.classList.remove('is--loading');
    });
  }, true);

  document.addEventListener('pb:primary-variant-change', function (e) {
    var detail = e && e.detail;
    if (!detail || !detail.variantId) return;
    primary.variantId = parseInt(detail.variantId, 10);
    primary.price = parseInt(detail.price, 10) || 0;
    if (detail.title) primary.title = detail.title;
    root.setAttribute('data-bb-primary-variant', String(primary.variantId));
    root.setAttribute('data-bb-primary-price', String(primary.price));
    if (detail.title) root.setAttribute('data-bb-primary-title', detail.title);

    var bundlePrimary = root.querySelector('[data-bb-bundle-primary] .t4s-product-buy-box__bundle-item-name');
    if (bundlePrimary && detail.title) bundlePrimary.textContent = detail.title;

    options.forEach(function (tier) {
      var tierQty = parseInt(tier.getAttribute('data-bb-qty-option'), 10) || 1;
      tier.setAttribute('data-bb-base-total', String(primary.price * tierQty));
      updateTierPrice(tier);
    });
    publishBundleState();
  });

  var selected = root.querySelector('[data-bb-qty-option].is-selected') || options[0];
  if (selected) selectOption(selected);
})();
